import { useCurrency } from 'react-easyrocket';
import { useIsUkGuest } from '../useIsUkGuest';

/** Обязательно в проекте использовать именно этот хук вместо useCurrency!
 * Он учитывает исключительное поведение для GBR локали, где для неавторизованных
 * пользователей без реферальной ссылки нельзя показывать фунты. Чтобы не аффектить
 * поведение библиотечного useCurrency - мы наследуемся от него здесь и дополняем
 * некоторые условия на currencyName и currencyIcon
 */
export const useLocalCurrency = (): ReturnType<typeof useCurrency> => {
  const currency = useCurrency();
  const isUkGuest = useIsUkGuest();
  const currencyIcon = isUkGuest ? '€' : currency.currencyIcon;
  const iconWithBalance = isUkGuest
    ? `${currencyIcon} ${currency.currentBalance}`
    : currency.iconWithBalance;
  const currencyName = isUkGuest ? 'EUR' : currency.currencyName;

  return {
    ...currency,
    currencyName,
    currencyIcon,
    iconWithBalance
  };
};
